<div class="gridItemChildModule w-100 h-100 d-flex flex-column KPITrendContentContainer" #KPITrendContent>
    <div id="KPITrendValue" class="container" *ngIf="!noData && !intervalRangeTooWide">
        <div id="trendLeftSection" class="left-section" [ngClass]="{'width-50': moduleDisplay === 'compact'}">
            <span class="metric-title" title="{{ metricName }}">{{ metricName }}</span>
            <div class="trend-data">
                <span class="mr-2 currentValue" title="{{ currentValue }}">{{ currentValue }}</span>
                <span class="ml-1 trend" *ngIf="trendDifference !== 0 && trendDisplayValue !== null || trendShowDirection">
                    <svg *ngIf="trendShowDirection" class="mr-1 iconContainer" [ngStyle]="{ fill : dynamicColor }">
                        <use *ngIf="arrowDirection"
                            href="../App_Themes/CXone/icons/cxone-up-arrow.svg#up-arrow"></use>
                        <use *ngIf="!arrowDirection"
                            href="../App_Themes/CXone/icons/cxone-down-arrow.svg#down-arrow"></use>
                    </svg>
                    <span id="trendDisplayValue" *ngIf="trendDifference !== 0 && trendDisplayValue !== null" [ngStyle]="{ color : dynamicColor }" title="{{ trendDisplayValue }}">{{ trendDisplayValue }}</span>
                </span>
            </div>
        </div>
        <span *ngIf="currentValue" class="border"></span>
        <div id="trendMiddleSection" class="middle-section">
            <span id="previousLabel" class="previous-label">{{ previousLabel }}</span>
            <span id="previousValue" class="previous-value">{{ previousValue }}</span>
        </div>
        <div *ngIf="!ViewBy?.includes('Company') && moduleDisplay === 'detailed'" id="trendRightSection" class="right-section">
            <cxone-multiselect-dropdown [ngModel]="selectedTrendItems" [options]="trendItems"
                (selectionChanged)="onCxOneSelectChange($event)" [disabled]="false" [isLoading]="false"
                [isRequired]="false" [maxItemsToDisplay]="1000" [maxSelectionLimit]="5"
                [bulkOperations]="false" [placeholder]="trendDropdownPlaceholder"
            ></cxone-multiselect-dropdown>
        </div>
    </div>

    <div id="KPITrendChartArea" *ngIf="!noData && !intervalRangeTooWide">
        <div class="chartScaler">
            <canvas baseChart *ngIf="chartConfig" [type]="chartConfig.type"
                [legend]="chartConfig.options.plugins.legend.display" [datasets]="chartConfig.data.datasets"
                [labels]="chartConfig.data.labels" [options]="chartConfig.options" [plugins]="chartConfig.plugins"
                (mouseout)="onMouseOut($event)">
            </canvas>
        </div>
    </div>
    <app-module-error class="flex-fill" *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
    <app-module-error class="flex-fill" *ngIf="intervalRangeTooWide" [intervalRangeTooWide]="true"></app-module-error>
    <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
</div>